function baseProps(className) {
  return {
    className,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.8',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true'
  };
}

export function CartIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <circle cx="9" cy="20" r="1.5" />
      <circle cx="18" cy="20" r="1.5" />
      <path d="M3 4h2l2.1 10.2a1 1 0 0 0 1 .8h9.7a1 1 0 0 0 1-.8L21 7H7" />
    </svg>
  );
}

export function CheckCircleIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.3 2.3 4.7-4.8" />
    </svg>
  );
}

export function FlaskIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M10 3v5.4L5.8 16a3 3 0 0 0 2.6 4.5h7.2a3 3 0 0 0 2.6-4.5L14 8.4V3" />
      <path d="M9 3h6" />
      <path d="M8.2 14h7.6" />
    </svg>
  );
}

export function SproutIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M12 20v-7" />
      <path d="M12 13c0-3.9 3.1-7 7-7 0 3.9-3.1 7-7 7Z" />
      <path d="M12 16c0-3.3-2.7-6-6-6 0 3.3 2.7 6 6 6Z" />
    </svg>
  );
}

export function DropletsIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M7.5 14.5A3.5 3.5 0 1 0 11 18c0-2.3-3.5-6.5-3.5-6.5S4 15.7 4 18a3.5 3.5 0 0 0 3.5 3.5" />
      <path d="M16.5 10.5A3.5 3.5 0 1 0 20 14c0-2.3-3.5-6.5-3.5-6.5S13 11.7 13 14a3.5 3.5 0 0 0 3.5 3.5" />
    </svg>
  );
}

export function WateringCanIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M14 9V5h3l2 2" />
      <path d="M6 18h9a2 2 0 0 0 2-2v-4.5a4.5 4.5 0 0 0-4.5-4.5H8a3 3 0 0 0-3 3v6a2 2 0 0 0 1 1.7Z" />
      <path d="M17 11h2.5a2.5 2.5 0 0 1 0 5H17" />
      <path d="M3 18h3" />
    </svg>
  );
}

export function CalendarIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M4 10h16" />
    </svg>
  );
}

export function SprayIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M9 10h6l1.5 2.5V20H7v-7.5Z" />
      <path d="M10 10V7.5A1.5 1.5 0 0 1 11.5 6H14" />
      <path d="M14 6V4h3" />
      <path d="M18 7h2M18.5 4.5 20 3M18.5 9.5 20 11" />
    </svg>
  );
}

export function SeedIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M12 20c4.5-2.2 6-7.2 6-11 0-1.1-.9-2-2-2-3.8 0-8.8 1.5-11 6" />
      <path d="M8 14c1.6-1.8 3.8-3.2 6.5-4.1" />
      <path d="M6 18c-1.2-1.1-2-2.8-2-4.7C4 10.7 6 8 8.8 6.9" />
    </svg>
  );
}

export function RecycleIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="m10 3 2 2-2 2" />
      <path d="M12 5H9a3 3 0 0 0-2.6 1.5L5 9" />
      <path d="m19 12-2 1 1 2" />
      <path d="M17 13l-1.5-2.6A3 3 0 0 0 12.9 9H10" />
      <path d="m7 19-1-2 2-1" />
      <path d="M6 17h3a3 3 0 0 0 2.6-1.5L13 13" />
    </svg>
  );
}

export function LightbulbIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a6 6 0 0 0-3.7 10.7c.8.6 1.2 1.4 1.5 2.3h4.4c.3-.9.7-1.7 1.5-2.3A6 6 0 0 0 12 2Z" />
    </svg>
  );
}

export function StarIcon({ className = 'ui-icon', filled = false }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m12 3.8 2.5 5 5.5.8-4 3.9.9 5.5L12 16.4 7.1 19l.9-5.5-4-3.9 5.5-.8Z" />
    </svg>
  );
}

export function ChevronLeftIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="m15 18-6-6 6-6" />
    </svg>
  );
}

export function ChevronRightIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}

export function PlusIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function MinusIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M5 12h14" />
    </svg>
  );
}

export function CloseIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
}

export function PlayIcon({ className = 'ui-icon' }) {
  return (
    <svg {...baseProps(className)}>
      <circle cx="12" cy="12" r="9" />
      <path d="m10 8 6 4-6 4z" fill="currentColor" stroke="none" />
    </svg>
  );
}
